import { PageHeader } from "@shared/components/PageHeader";
import React from "react";
import MessageActivityDashboard from "../dashboard/dashboard";
import MessageActivityList from "../list/list";

const MessageActivityLanding = () => {
  return (
    <div className="space-y-6 p-1">
      <PageHeader
        title="Message Activity"
        subtitle="View all communication activities including workflow, bulk, and individual messages"
      />
      <div className="mt-1">
        <MessageActivityDashboard />
      </div>
      <div className="mt-1">
        <MessageActivityList />
      </div>
    </div>
  );
};

export default MessageActivityLanding;
